module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.arr), function(items, i) {
    return _c('div', {
      staticClass: "item"
    }, [_c('p', {
      staticClass: "status"
    }, [_vm._v(_vm._s(i + 1) + " из " + _vm._s(_vm.arr.length))]), _vm._v(" "), _c('ul', {
      staticClass: "grid s_1 m_2 l_4"
    }, _vm._l((items), function(item) {
      return _c('li', [_c('div', {
        staticClass: "block"
      }, [(item.img) ? _c('a', {
        staticClass: "img",
        style: (("background-image: url(" + (item.img) + ")")),
        attrs: {
          "href": item.href
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "bottomBlock"
      }, [(item.text) ? _c('a', {
        staticClass: "slTitle",
        attrs: {
          "href": item.href
        }
      }, [_vm._v(_vm._s(item.text))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "priceAndBuy"
      }, [_c('div', {
        staticClass: "priceContainer"
      }, [_c('p', {
        staticClass: "sale"
      }, [(item.priceText) ? _c('span', [_vm._v(_vm._s(item.priceText))]) : _vm._e(), _vm._v(" "), (item.oldPrice) ? _c('span', {
        staticClass: "oldPrice",
        domProps: {
          "innerHTML": _vm._s(item.oldPrice)
        }
      }) : _vm._e()]), _vm._v(" "), (item.price) ? _c('p', {
        staticClass: "price",
        domProps: {
          "innerHTML": _vm._s(item.price)
        }
      }) : _vm._e()]), _vm._v(" "), (item.href) ? _c('a', {
        staticClass: "buy  waves-effect waves-light",
        attrs: {
          "href": item.href
        }
      }, [_c('svg', {
        staticStyle: {
          "enable-background": "new 0 0 512 512"
        },
        attrs: {
          "xmlns": "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "version": "1.1",
          "id": "Layer_1",
          "x": "0px",
          "y": "0px",
          "viewBox": "0 0 512 512",
          "xml:space": "preserve"
        }
      }, [_c('path', {
        attrs: {
          "d": "M501.333,213.331h-90.388L296.792,47.289c-3.333-4.854-9.969-6.073-14.833-2.75c-4.854,3.344-6.083,9.979-2.75,14.833    l105.846,153.958H126.945L232.792,59.373c3.333-4.854,2.104-11.49-2.75-14.833c-4.833-3.323-11.479-2.104-14.833,2.75    L101.055,213.331H10.667C4.771,213.331,0,218.102,0,223.998c0,5.896,4.771,10.667,10.667,10.667h13.533l65.207,204.938    c5.667,17.781,22,29.729,40.656,29.729h251.875c18.656,0,34.99-11.948,40.656-29.74l65.206-204.927h13.534    c5.896,0,10.667-4.771,10.667-10.667C512,218.102,507.229,213.331,501.333,213.331z M402.26,433.123    c-2.833,8.896-11,14.875-20.323,14.875H130.063c-9.323,0-17.49-5.979-20.323-14.865L46.589,234.664h418.823L402.26,433.123z"
        }
      })])]) : _vm._e()])])])])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-26e57eb7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/popProduct.vue
// module id = 314
// module chunks = 22